import { Product } from "@/types/broadbandProduct";

export const filterProducts = (
	products: Product[],
	contractFilters: Array<{
		name: string;
		value: string | number;
		isChecked: boolean;
	}>,
	networkFilters: Array<{
		name: string;
		value: string | number;
		isChecked: boolean;
	}>,
	speedFilters: Array<{
		name: string;
		value: string | number;
		isChecked: boolean;
	}>
): Product[] => {
	contractFilters = contractFilters.filter((c) => c.isChecked === true);
	networkFilters = networkFilters.filter((n) => n.isChecked === true);
	speedFilters = speedFilters.filter((s) => s.isChecked === true);

	return products.filter((product) => {
		if (contractFilters.length) {
			if (
				!contractFilters.find(
					(c) => c.value.toString() === product.contract_length
				)
			)
				return false;
		}

		if (networkFilters.length) {
			if (!networkFilters.find((n) => n.value === product.network.name))
				return false;
		}

		if (speedFilters.length) {
			if (
				!speedFilters.find(
					(s) => Number(s.value) <= Number(product.download_speed)
				)
			)
				return false;
		}

		return true;
	});
};
